import HigSideNav from '@hig/side-nav';
const Submodule = HigSideNav.Submodule;

export default Submodule;
